export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CASTING_SAND.66751cdf.png";